import React from 'react'

import { Formik, Form } from 'formik'

import { Button, Stack } from '@mui/material'

import { useAuth } from '@/hooks/useAuth'

import { cardFormInitialValues, cardFormValidationSchema } from './types'
import { useCardAddFormSubmit } from './useCardAddFormSubmit'
import { CardFormFields } from './CardFormFields'

export { CardFormFields } from './CardFormFields'
export { cardFormInitialValues, cardFormValidationSchema } from './types'
export type { CardFormData } from './types'
export { useCardAddFormSubmit } from './useCardAddFormSubmit'

export interface CardAddFormProps {
  onSuccess: (cardId?: number) => void
}

export const CardAddForm: React.FC<CardAddFormProps> = ({ onSuccess }) => {
  const { user } = useAuth()
  const handleSubmit = useCardAddFormSubmit(onSuccess)

  return (
    <Formik initialValues={cardFormInitialValues} validationSchema={cardFormValidationSchema} onSubmit={handleSubmit}>
      {({ submitForm, isSubmitting }) => (
        <Form>
          <Stack direction="column" spacing={3}>
            <CardFormFields />
            <Button
              variant="contained"
              color="primary"
              onClick={submitForm}
              loading={isSubmitting}
              disabled={isSubmitting || !user?.phone}
              sx={{ borderRadius: 20 }}
            >
              Adicionar
            </Button>
          </Stack>
        </Form>
      )}
    </Formik>
  )
}
